import {call, fork, put, select, take, takeLatest} from 'redux-saga/effects'

import {CheckoutFunnels, EventRoles, EventTypeNames, EventTypes} from '../../store/enum'

import * as checkoutActions from '../../actions/checkout'
import * as dashboardActions from '../../actions/dashboard'
import * as helloBarActions from '../../actions/helloBar'
import * as checkoutSelectors from '../../store/checkout'
import * as crossSelectors from '../../store/cross'
import * as eventSelectors from '../../store/events'
import * as looksSelectors from '../../store/looks'
import * as paneSelectors from '../../store/pane'
import * as routerSelectors from '../../store/router'

import * as track from '../../track/checkout'
import * as URLS from '../../urls'

/**
 * Users can, unfortunately, open the dashboard and edit their order while in
 * checkout. This saga is necessary to re-validate the checkout order anytime
 * the dashboard closes while in checkout.
 */
export function* validateOnDashboardInteraction() {
  while (true) {
    yield take(dashboardActions.CLOSE_DASHBOARD)
    const pathname = yield select(routerSelectors.pathname)
    if (pathname === URLS.CHECKOUT) {
      yield put(checkoutActions.validatePrecheckout())
    }
  }
}

export function* trackStartCheckout() {
  const isOwner = yield select(crossSelectors.userIsOwner)
  const eventType = yield select(eventSelectors.currentEventTypeName)
  const eventId = yield select(eventSelectors.currentId)
  const isMobile = yield select(paneSelectors.windowIsPhone)
  const daysToEvent = yield select(eventSelectors.currentEventDaysAway)
  const orderTypes = yield select(looksSelectors.getOrderTypesInLooks)
  yield call(track.checkoutStarted, {
    isOwner,
    eventType,
    eventId,
    isMobile,
    daysToEvent,
    orderTypes,
  })
}

/**
 * Every time checkout starts, we want to assess which funnel to use and set those
 * steps in state. This is because user input during the checkout process could
 * cause the funnel to re-calculate, which we do not want. Hence the logic is
 * here and not in a selector.
 */
export function* setCheckoutSteps() {
  const userIsOwner = yield select(crossSelectors.userIsOwner)
  const currentRole = yield select(eventSelectors.currentOwnerRole)
  const eventType = yield select(eventSelectors.currentEventTypeName)
  const hasPartnerInfo = yield select(eventSelectors.currentEventHasPartnerInfo)
  let steps = CheckoutFunnels.default
  if (
    userIsOwner &&
    eventType === EventTypeNames[EventTypes.wedding] &&
    [EventRoles.groom, EventRoles.bride].includes(currentRole) &&
    !hasPartnerInfo
  ) {
    steps = CheckoutFunnels.coreg
  }
  yield put(checkoutActions.setCheckoutSteps(steps))
}

/**
 * Runs all validation necessary when a user navigates to checkout
 */
export function* startCheckoutWorker() {
  yield fork(setCheckoutSteps)
  yield put(helloBarActions.deactivateHelloBar())
  yield call(trackStartCheckout)

  const shouldShowCheckoutContent = yield select(checkoutSelectors.shouldShowCheckoutContent)
  if (!shouldShowCheckoutContent) {
    return
  }

  yield call(validateOnDashboardInteraction)
}

export function* startCheckoutSaga() {
  yield takeLatest(checkoutActions.START_CHECKOUT, startCheckoutWorker)
}
